<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 11.6 11.55"
    style="enable-background: new 0 0 11.6 11.55"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`h-${height} w-${width}`]: true,
    }"
  >
    <g>
      <g>
        <path
          class="st0"
          d="M-28.36,25.07h-11.55v-4.09l3.3-3.3l0.44,0.44v-4.6h7.81V25.07z M-33.31,24.39h4.27v-10.2h-6.46v4.6
			l2.19,2.19V24.39z M-39.24,24.39h5.26v-3.14l-2.63-2.63l-2.63,2.63V24.39z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M-33.12,16.83h-1.15c-0.16,0-0.28-0.13-0.28-0.28v-1.15c0-0.16,0.13-0.28,0.28-0.28h1.15
			c0.16,0,0.28,0.13,0.28,0.28v1.15C-32.84,16.7-32.97,16.83-33.12,16.83z M-34.22,16.49h1.04v-1.04h-1.04V16.49z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M-33.12,19.73h-1.15c-0.16,0-0.28-0.13-0.28-0.28V18.3c0-0.16,0.13-0.28,0.28-0.28h1.15
			c0.16,0,0.28,0.13,0.28,0.28v1.15C-32.84,19.6-32.97,19.73-33.12,19.73z M-34.22,19.39h1.04v-1.04h-1.04V19.39z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M-30.24,16.83h-1.15c-0.16,0-0.28-0.13-0.28-0.28v-1.15c0-0.16,0.13-0.28,0.28-0.28h1.15
			c0.16,0,0.28,0.13,0.28,0.28v1.15C-29.96,16.7-30.09,16.83-30.24,16.83z M-31.34,16.49h1.04v-1.04h-1.04V16.49z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M-30.24,19.73h-1.15c-0.16,0-0.28-0.13-0.28-0.28V18.3c0-0.16,0.13-0.28,0.28-0.28h1.15
			c0.16,0,0.28,0.13,0.28,0.28v1.15C-29.96,19.6-30.09,19.73-30.24,19.73z M-31.34,19.39h1.04v-1.04h-1.04V19.39z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M-30.24,22.63h-1.15c-0.16,0-0.28-0.13-0.28-0.28V21.2c0-0.16,0.13-0.28,0.28-0.28h1.15
			c0.16,0,0.28,0.13,0.28,0.28v1.15C-29.96,22.51-30.09,22.63-30.24,22.63z M-31.34,22.3h1.04v-1.04h-1.04V22.3z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M-36.08,23.32h-1.15c-0.16,0-0.28-0.13-0.28-0.28v-1.15c0-0.16,0.13-0.28,0.28-0.28h1.15
			c0.16,0,0.28,0.13,0.28,0.28v1.15C-35.79,23.2-35.92,23.32-36.08,23.32z M-37.17,22.98h1.04v-1.04h-1.04V22.98z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          class="st0"
          d="M11.49,31.19H2c-0.58,0-1.06-0.48-1.06-1.06v-9.49c0-0.58,0.47-1.06,1.06-1.06h9.49
			c0.58,0,1.06,0.47,1.06,1.06v9.49C12.54,30.72,12.07,31.19,11.49,31.19z M2,20.26c-0.21,0-0.38,0.17-0.38,0.38v9.49
			c0,0.21,0.17,0.38,0.38,0.38h9.49c0.21,0,0.38-0.17,0.38-0.38v-9.49c0-0.21-0.17-0.38-0.38-0.38H2z"
        />
      </g>
      <path
        class="st0"
        d="M8.02,21.11c-0.19,0-0.34,0.15-0.34,0.34c0,0.19,0.15,0.34,0.34,0.34h1.86l-6.76,6.74v-1.87
		c0-0.19-0.15-0.34-0.34-0.34c-0.19,0-0.34,0.15-0.34,0.34v3.02h3.02c0.19,0,0.34-0.15,0.34-0.34C5.8,29.15,5.65,29,5.46,29H3.6
		l6.76-6.74v1.87c0,0.19,0.15,0.34,0.34,0.34s0.34-0.15,0.34-0.34v-3.02H8.02z"
      />
    </g>
    <path
      class="st0"
      d="M-3.77,20.27v-0.09c0-0.28-0.23-0.51-0.51-0.51H-5.9c-0.28,0-0.51,0.23-0.51,0.51v0.09h-5.32v-1.14
	c0-0.22,0.18-0.41,0.41-0.41c0.22,0,0.41,0.18,0.41,0.41v0.13c0,0.19,0.15,0.34,0.34,0.34s0.34-0.15,0.34-0.34v-0.13
	c0-0.6-0.48-1.08-1.08-1.08s-1.08,0.49-1.08,1.08v1.14h-0.78v2.97c0,0.78,0.63,1.41,1.41,1.41h0.27v0.61h0.67v-0.61h6.99v0.61h0.67
	v-0.61h0.17c0.78,0,1.41-0.63,1.41-1.41v-2.97H-3.77z M-5.73,20.34h1.29v1.78h-1.29V20.34z M-2.25,23.24c0,0.41-0.33,0.74-0.74,0.74
	h-8.77c-0.41,0-0.74-0.33-0.74-0.74v-2.29h6.1v1.85h2.64v-1.85h1.52V23.24z"
    />
    <path
      class="st0"
      d="M-15.46,21.86c0-0.48-0.39-0.87-0.87-0.87h-0.17v-2.6c0-0.48-0.39-0.87-0.87-0.87h-7.77
	c-0.48,0-0.87,0.39-0.87,0.87v2.6h-0.17c-0.48,0-0.87,0.39-0.87,0.87v2.52h0.91v0.61h0.67v-0.61h8.44v0.61h0.67v-0.61h0.91V21.86z
	 M-25.35,18.39c0-0.11,0.09-0.2,0.2-0.2h7.77c0.11,0,0.2,0.09,0.2,0.2v2.6h-0.52v-0.97c0-0.27-0.22-0.49-0.49-0.49h-2.08
	c-0.27,0-0.49,0.22-0.49,0.49v0.97h-1.02v-0.97c0-0.27-0.22-0.49-0.49-0.49h-2.08c-0.27,0-0.49,0.22-0.49,0.49v0.97h-0.52V18.39z
	 M-18.03,20.99h-2.38v-0.97c0-0.08,0.07-0.15,0.15-0.15h2.08c0.09,0,0.15,0.07,0.15,0.15V20.99z M-22.11,20.99h-2.38v-0.97
	c0-0.08,0.07-0.15,0.15-0.15h2.08c0.08,0,0.15,0.07,0.15,0.15V20.99z M-16.13,23.71h-10.26v-1.84c0-0.11,0.09-0.2,0.2-0.2h9.86
	c0.11,0,0.2,0.09,0.2,0.2V23.71z"
    />
    <g>
      <path
        class="st0"
        d="M10.36,11.58H1.23c-0.68,0-1.24-0.56-1.24-1.24V1.21c0-0.68,0.56-1.24,1.24-1.24h9.13
		c0.68,0,1.24,0.56,1.24,1.24v9.13C11.6,11.02,11.04,11.58,10.36,11.58z M1.23,0.65c-0.31,0-0.56,0.25-0.56,0.56v9.13
		c0,0.31,0.25,0.56,0.56,0.56h9.13c0.31,0,0.56-0.25,0.56-0.56V1.21c0-0.31-0.25-0.56-0.56-0.56H1.23z"
      />
    </g>
    <g>
      <g>
        <path
          class="st0"
          d="M4.94,9.43H2.91V2.12H5.4c1.14,0,1.51,0.06,1.68,0.11C7.54,2.35,7.92,2.61,8.22,3c0.3,0.39,0.46,0.9,0.46,1.5
			c0,0.46-0.09,0.86-0.26,1.19c-0.17,0.33-0.4,0.59-0.67,0.77C7.48,6.64,7.21,6.77,6.93,6.83c-0.35,0.07-0.84,0.1-1.46,0.1H4.94
			V9.43z M3.6,8.75h0.65v-2.5h1.22c0.58,0,1.02-0.03,1.32-0.09C6.97,6.12,7.17,6.03,7.36,5.9c0.18-0.13,0.33-0.3,0.46-0.53
			C7.93,5.14,7.99,4.85,7.99,4.5c0-0.45-0.11-0.81-0.31-1.08C7.47,3.14,7.22,2.97,6.91,2.89C6.76,2.85,6.38,2.8,5.4,2.8H3.6V8.75z
			 M5.33,5.81H4.25V3.24h0.99c0.51,0,0.84,0.02,1.03,0.05C6.56,3.34,6.8,3.48,7,3.69c0.2,0.22,0.3,0.5,0.3,0.83
			c0,0.27-0.07,0.51-0.21,0.71C6.95,5.43,6.75,5.58,6.51,5.68C6.37,5.73,6.1,5.81,5.33,5.81z M4.94,5.12h0.39
			c0.66,0,0.87-0.06,0.94-0.08c0.11-0.04,0.2-0.11,0.26-0.2c0.06-0.09,0.09-0.19,0.09-0.32c0-0.16-0.04-0.27-0.12-0.37
			c-0.09-0.1-0.2-0.16-0.35-0.19c-0.08-0.02-0.3-0.04-0.9-0.04h-0.3V5.12z"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
<style scoped>
.st0 {
  fill: #010101;
}
</style>
